const nextTick = func => setTimeout(func, 0)

const header = () => new Promise(resolve => {
  const root = document.querySelector('.header')
  const more = root.querySelector('.header-more')
  const player = root.querySelector('.header-video-player')

  const nodes = [
    document.querySelector('.nav'),
    document.querySelector('.stars'),
    root.querySelector('.header-video'),
    root.querySelector('.header-heading'),
    root.querySelector('.header-subhead'),
    root.querySelector('.header-copy-small'),
    root.querySelector('.header-copy-large'),
    root.querySelector('.header-form'),
    more
  ]

  const handlePlayer = () => new Promise(resolve => {
    // play video when ready
    const ready = () => {
      player.play()
      resolve()
    }

    // is ready
    if (player.readyState >= 2) {
      ready()
      return
    }

    // is not ready yet
    player.addEventListener('canplay', ready)
  })

  const handleMore = () => new Promise(resolve => {
    more.addEventListener('transitionend', resolve)
  })

  const promises = [
    handlePlayer(),
    handleMore()
  ]

  Promise
    .all(promises)
    .then(resolve)

  nextTick(() => {
    window.requestAnimationFrame(() => {
      nodes.forEach(node => node.classList.add('is-active'))
    })
  })
})

export default header
